import { render, staticRenderFns } from "./pie-com.vue?vue&type=template&id=b7c01752&"
import script from "./pie-com.vue?vue&type=script&lang=js&"
export * from "./pie-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports